document.addEventListener('DOMContentLoaded', function() {
  const newsletterForm = document.querySelector('.newsletter-form');

  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent immediate submission

      const emailInput = this.querySelector('input[name="contact[email]"]');
      const email = emailInput ? emailInput.value : '';
      sessionStorage.setItem('newsletter_email', email);
      
      if (typeof Shopify !== 'undefined' && Shopify.analytics) {
        Shopify.analytics.publish('email_signup', { email: email });
      }
      
      // Submit the form normally after a brief delay to ensure analytics fires
      setTimeout(function() {
        //newsletterForm.submit();
      }, 100);
    });
  }
});
